'use client'

import Image from 'next/image'
import Link from 'next/link'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useElementVisible } from '@hooks/useElementVisible'
import { PlayYourPartMock } from '@components/AboutUs/AboutUsMock'
import { EVENTS } from '@configs/events.config'
import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import styles from './PlayYourPart.module.scss'

const PlayYourPart = () => {
  const contentSection = useElementVisible({ threshold: 0.5 })
  const handleClick = async () => {
    await trackEvent(EVENTS[TENANT_TYPE.ABOUTUS].engage.eventname, {
      ...EVENTS[TENANT_TYPE.ABOUTUS].engage.eventProps,
      journey: 'career',
      redirection_url: PlayYourPartMock?.buttonLink,
    })
  }

  return (
    <div className={styles.mainWrapper}>
      <div ref={contentSection.ref} className={styles.content}>
        <div className={`${styles.textContainer} ${contentSection.isVisible ? styles.visible : ''}`}>
          <span className={styles.heading}>{PlayYourPartMock?.title}</span>
          <span className={styles.subHeading}>{PlayYourPartMock?.description}</span>
          <Link
            className={styles.joinUsButton}
            href={PlayYourPartMock?.buttonLink}
            target="_blank"
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleClick}>
            {PlayYourPartMock?.buttonText}
          </Link>
        </div>
        <div className={`${styles.bannerImage} ${contentSection.isVisible ? styles.animate : ''}`}>
          <Image height={420} width={420} src={PlayYourPartMock?.bannerImageSrc} alt="Acko building" />
        </div>
      </div>
    </div>
  )
}

export default PlayYourPart
